import { clientRepo } from '$lib/states/client-repo.svelte';

import { Bench } from './bench';

export async function createNewDefaultChat() {
	Bench.mark('new-default-chat');

	Bench.mark('new-default-chat.get-last-used-settings');
	const lastUsedSettings = await clientRepo.repo?.getLastUsedChatInferenceSettings();
	Bench.measure('new-default-chat.get-last-used-settings');

	Bench.mark('new-default-chat.get-default-prompt');
	const defaultPrompt = await clientRepo.repo?.getDefaultPrompt();
	Bench.measure('new-default-chat.get-default-prompt');

	const systemPrompt = defaultPrompt?.content || '';

	Bench.mark('new-default-chat.get-chat-settings');
	const inferenceSettingsPreset =
		lastUsedSettings || (await clientRepo.repo?.getDefaultChatInferenceSettings());
	Bench.measure('new-default-chat.get-chat-settings');

	if (!inferenceSettingsPreset) {
		throw new Error('Failed to find default chat inference settings.', {
			cause: inferenceSettingsPreset
		});
	}

	Bench.mark('new-default-chat.create-settings');
	const inferenceSettings = await clientRepo.repo?.upsertInferenceSettings({
		...inferenceSettingsPreset,
		id: undefined
	});
	Bench.measure('new-default-chat.create-settings');

	if (!inferenceSettings) {
		throw new Error('Failed to create chat inference settings.', {
			cause: inferenceSettings
		});
	}

	Bench.mark('new-default-chat.create-chat');
	const chat = await clientRepo.repo?.upsertChat({
		inferenceSettingsId: inferenceSettings.id,
		systemPrompt
	});
	Bench.measure('new-default-chat.create-chat');

	if (!chat) {
		throw new Error('Failed to create chat.', { cause: chat });
	}

	Bench.measure('new-default-chat');

	return chat;
}
